export const SortKeys = {
  Name: "name",
  SyncingTo: "syncs_aggregate.count",
  Kpi: "kpi",
  LastUpdated: "updated_at",
} as const;

export const DEFAULT_AUDIENCE_SORT_KEY = SortKeys.LastUpdated;
export const AUDIENCE_SORT_OPTIONS = Object.values(SortKeys);
